// extracted by mini-css-extract-plugin
export default {"root":"Date__root--xyVKT"};